import { useAppUpdate } from "@/lib/appUpdate";

/** בודק גרסה חדשה במעבר דפים / חזרה לטאב */
export default function AppUpdateWatcher() {
  useAppUpdate();
  return null;
}
